import styled from 'styled-components';

export const StyledAddFirstWidgetResult = styled.div`
    display: flex;
    flex-direction: column;
    width: 37%;
    .content {
        line-height: 1.6;
        text-align: center;
    }
    .upto {
        margin-top: 1.6px;
    }
    .subcontent {
        margin-top: 15px;
    }
    .add-widget-button {
        margin-top: 20px;
        border-radius: 25px;
    }
`;
